import { LogOut, Menu, UserRound } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useNavigate } from 'react-router-dom'

import { useLogoutMutation } from '@/api/mutations/auth'
import { Button } from '@/components/ui/button'
import { Sheet } from '@/components/ui/sheet'
import { useAuthStore } from '@/stores/auth.store'
import { useWorkbenchStore } from '@/stores/workbench.store'

export const MobileMenuSheet = () => {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const resetWorkbench = useWorkbenchStore((state) => state.reset)
  const logout = useLogoutMutation()

  const handleLogout = () => {
    logout.mutate(undefined, {
      onSettled: () => {
        resetWorkbench()
        setOpen(false)
        navigate('/login', { replace: true })
      },
    })
  }

  return (
    <>
      <Button variant="ghost" size="icon" aria-label={t('actions.open_menu')} onClick={() => setOpen(true)}>
        <Menu className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} />
      </Button>
      <Sheet open={open} title={t('menu')} onOpenChange={setOpen}>
        <div className="space-y-4">
          <div className="rounded-lg border border-card-border bg-background p-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-soft text-primary">
                <UserRound className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} />
              </span>
              <div>
                <div className="text-sm font-semibold">{user?.name ?? t('profile')}</div>
                <div className="text-xs text-muted-foreground">{user?.role ?? '-'}</div>
              </div>
            </div>
          </div>
          <nav className="grid gap-2">
            <Button variant="ghost" asChild>
              <NavLink to="/library" onClick={() => setOpen(false)}>
                {t('product_library')}
              </NavLink>
            </Button>
            <Button variant="ghost" asChild>
              <NavLink to="/settings" onClick={() => setOpen(false)}>
                {t('profile')}
              </NavLink>
            </Button>
          </nav>
          <Button variant="outline" className="w-full" disabled={logout.isPending} onClick={handleLogout}>
            <LogOut className="h-4 w-4" aria-hidden="true" strokeWidth={1.5} />
            {t('actions.logout')}
          </Button>
        </div>
      </Sheet>
    </>
  )
}
